import { LocalStorageRepository } from '@domain/repositories/LocalStorageRepository'
import AsyncStorage from '@react-native-async-storage/async-storage'

export class LocalStorage implements LocalStorageRepository {
  async getItem<T>(key: string): Promise<T | undefined> {
    const data = await AsyncStorage.getItem(key)
    if (!data) return
    const dataObj = JSON.parse(data)
    return dataObj
  }
  async setItem(key: string, data: any): Promise<void> {
    const dataStr = JSON.stringify(data)
    await AsyncStorage.setItem(key, dataStr)
  }
  async removeItem(key: string): Promise<void> {
    await AsyncStorage.removeItem(key)
  }
}
